import { DOMAttributes } from "react";
import * as React from "react";

import { Icon, IconsEnum } from "components/icon";
import { IWithTestSelector } from "components/interfaces";

import { itemContentWrapper, itemName, responseArrow, responseArrowWrapper } from "./styles";

interface IProps extends IWithTestSelector {
  name: string;
  onArrowClick: DOMAttributes<HTMLDivElement>["onClick"];
}

export const CannedResponseItem: React.FC<IProps> = ({ testSelector, name, onArrowClick }) => (
  <div data-testid={testSelector} css={itemContentWrapper}>
    <div data-testid="back-shortcuts-button" css={responseArrowWrapper} onClick={onArrowClick}>
      <Icon css={responseArrow} name={IconsEnum.ArrowRightShort} width="4px" height="8px" fill="#000000" />
    </div>
    <div data-testid="canned-response-text" css={itemName}>
      {name}
    </div>
  </div>
);
